import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.includes.js";
import { owlAddError } from '@/utils/monitor-err/index';

// show域名黑名单：正式上线，从黑名单中去除 show.test.maoyan.com 的域名，避免测试环境引发告警污染
var HOST_BLACK_LIST = ['show.maoyan.com'];
export function reportNativeHostWarning(Drip) {
  var _window$location = window.location,
    hostname = _window$location.hostname,
    href = _window$location.href,
    pathname = _window$location.pathname,
    search = _window$location.search,
    hash = _window$location.hash;
  var uaInfo = (Drip === null || Drip === void 0 ? void 0 : Drip.UA) || {};
  var isShowHost = HOST_BLACK_LIST.includes(hostname);
  // 确定当前渠道，限定美大猫
  var isTargetContainer = uaInfo.IS_MAOYAN || uaInfo.IS_MEITUAN || uaInfo.IS_DIANPING;
  if (!isShowHost || !isTargetContainer) return;
  owlAddError({
    name: 'Native容器访问show域名告警',
    msg: {
      appName: uaInfo.appName,
      host: hostname,
      href: href,
      pathname: pathname,
      search: search,
      hash: hash,
      ua: navigator.userAgent
    }
  }, {
    category: 'jsError',
    level: 'error'
  });
}